// Vrai la première fois qu'une clé est vue dans l'onglet (sessionStorage), faux
// ensuite. Sans stockage disponible (navigation privée, accès refusé) on
// retombe sur « vrai » : mieux vaut un doublon qu'un évènement perdu.
export function firstViewInSession(key, storage = globalThis.sessionStorage) {
  try {
    if (storage.getItem(key)) return false
    storage.setItem(key, "1")
  } catch {}
  return true
}
